import "./search-bar.css";
import { SearchBar } from './search-bar';
export default SearchBar;